/**
 * HabitPack Centralized Error Logger
 * Captures system breaches and transmission failures for the registry.
 */

export interface ErrorMetadata {
  type?: 'api-query' | 'api-mutation' | 'ui-crash' | 'uncaught'
  route?: string
  user?: string
  timestamp: string
  [key: string]: any
}

export function logError(error: Error | unknown, metadata: Partial<ErrorMetadata> = {}) {
  const timestamp = new Date().toISOString()
  const errorObj = error instanceof Error ? error : new Error(String(error))
  
  const payload = {
    severity: 'CRITICAL',
    protocol: 'HABITPACK_CORE',
    timestamp,
    error: {
      name: errorObj.name,
      message: errorObj.message,
      stack: errorObj.stack,
    },
    context: {
      ...metadata,
      route: metadata.route || window.location.pathname,
    },
  }

  // Structured logging for the console registry
  // Reflected OKLCH values for theme parity (even in dev console)
  console.group('%c SIGNAL BREACH DETECTED ', 'background: oklch(0.6 0.2 25); color: oklch(0.99 0.005 25); font-weight: bold; padding: 2px 4px; border-radius: 2px;')
  console.log('%cTIMESTAMP:%c %s', 'color: oklch(0.85 0.18 165); font-weight: bold;', 'color: inherit;', payload.timestamp)
  console.log('%cTYPE:     %c %s', 'color: oklch(0.85 0.18 165); font-weight: bold;', 'color: inherit;', payload.context.type || 'UNKNOWN')
  console.log('%cMESSAGE:  %c %s', 'color: oklch(0.6 0.2 25); font-weight: bold;', 'color: inherit;', payload.error.message)
  console.dir(payload)
  console.groupEnd()

  return payload
}
